import * as React from 'react'

import { Box, Chevron, Popover, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  title: string
}

const Tooltip = ({ title, children }: React.PropsWithChildren<Props>) => {
  const [open, toggle] = useToggle()

  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
      title={title}
    >
      <Box flexDirection="row" alignItems="center">
        <Chevron direction={open ? 'up' : 'down'} type="terciary" />
      </Box>
      {children}
    </Popover.ItemList>
  )
}

export default observer(Tooltip)
